import { TaskExperience } from '@dialogue/silkroad'
import type { SupportedMemberTaskType } from 'APP/Store/MemberTasks'
import MemberTaskBannerBooking from './MemberTaskBannerBooking'
import MemberTaskViewBooking from './MemberTaskViewBooking'
import type { MemberTaskDefinition } from './types'

/**
 * Defines the mapping between supported task types -> their corresponding UI components.
 */
const MEMBER_TASK_REGISTRY: { [T in SupportedMemberTaskType]: MemberTaskDefinition<T> } = {
  [TaskExperience.BookAppointment]: {
    getId: (task) => task.parameters.booking_id,
    Banner: MemberTaskBannerBooking,
    View: MemberTaskViewBooking,
  },
}

/**
 * Retrieves the task definition for a given supported task type.
 */
export const getMemberTaskDefinition = <T extends SupportedMemberTaskType>(
  type: T
): MemberTaskDefinition<T> => MEMBER_TASK_REGISTRY[type]
